import { css } from 'lit';

var css_248z = css`:host{--sidenav-theme-color:#5925dc;--sidenav-sticky-top:0rem}ul{display:flex;flex-direction:column;gap:1rem;list-style:none;padding-left:0}.sticky{height:calc(100vh - var(--sidenav-sticky-top, 0rem));overflow-y:auto;position:sticky;top:var(--sidenav-sticky-top,0)}`;

export { css_248z as default };
//# sourceMappingURL=sgds-sidenav2.js.map
